import { parse, isValid, isAfter } from "date-fns"
import { z } from "zod"
import { bannerFileConstraints } from "./create.schema"

const timeRegex = /^\d{2}:\d{2}$/

const parseDateTime = (date?: string, time?: string) => {
  if (!date || !time) return null
  const hasSlash = date.includes("/")
  const formatType = hasSlash ? "dd/MM/yyyy HH:mm" : "yyyy-MM-dd HH:mm"
  const parsed = parse(`${date} ${time}`, formatType, new Date())
  return isValid(parsed) ? parsed : null
}

export const updateTmaisBannerSchema = z
  .object({
    title: z.string().min(1, { message: "Campo obrigatório" }),
    description: z.string().min(1, { message: "Campo obrigatório" }),
    mobile_redirect_to: z.string().min(1, { message: "Campo obrigatório" }),

    active_at_date: z.string().min(1, { message: "Campo obrigatório" }),
    active_at_time: z.string().min(1, { message: "Campo obrigatório" }).regex(timeRegex, { message: "Horário inválido" }),

    add_expiration: z.boolean().default(false),
    expires_at_date: z.string().optional(),
    expires_at_time: z.string().optional().refine((v) => !v || timeRegex.test(v), { message: "Horário inválido" }),

    file: z.instanceof(File).optional(),
  })
  .superRefine((data, ctx) => {
    const activeDateTime = parseDateTime(data.active_at_date, data.active_at_time)

    if (!activeDateTime) {
      ctx.addIssue({ path: ["active_at_date"], code: z.ZodIssueCode.custom, message: "Data de envio inválida" })
    }

    if (data.add_expiration) {
      if (!data.expires_at_date) ctx.addIssue({ path: ["expires_at_date"], code: z.ZodIssueCode.custom, message: "Campo obrigatório" })
      if (!data.expires_at_time) ctx.addIssue({ path: ["expires_at_time"], code: z.ZodIssueCode.custom, message: "Campo obrigatório" })

      const expiresAt = parseDateTime(data.expires_at_date, data.expires_at_time)

      if (data.expires_at_date && data.expires_at_time && !expiresAt) {
        ctx.addIssue({ path: ["expires_at_date"], code: z.ZodIssueCode.custom, message: "Data de expiração inválida" })
      }

      if (activeDateTime && expiresAt && !isAfter(expiresAt, activeDateTime)) {
        ctx.addIssue({ path: ["expires_at_date"], code: z.ZodIssueCode.custom, message: "Expiração deve ser maior que o envio" })
      }
    }

    if (data.file) {
      if (!bannerFileConstraints.mimeTypes.includes(data.file.type)) {
        ctx.addIssue({ path: ["file"], code: z.ZodIssueCode.custom, message: "Formato não suportado. Use PNG, JPEG ou GIF." })
      }
      const maxBytes = bannerFileConstraints.maxSizeInMb * 1024 * 1024
      if (data.file.size > maxBytes) {
        ctx.addIssue({ path: ["file"], code: z.ZodIssueCode.custom, message: `Tamanho máximo: ${bannerFileConstraints.maxSizeInMb}MB` })
      }
    }
  })

export type UpdateTmaisBannerValidationSchema = z.infer<typeof updateTmaisBannerSchema>